<script setup>
import { computed } from 'vue'

import AuditRecords from './AuditRecords.vue'
import { useAuditText } from './audit-text.js'

const props = defineProps({
  // characterRecord() 的结果。
  record: { type: Object, required: true },
  sources: { type: Map, required: true },
})

const { tr, rangeLabel } = useAuditText()
const attitudeRows = computed(() => props.record.latest_relations.map((relation) => ({
  key: `${relation.from_id}-${relation.to_id}-${relation.record_id || relation.job_id}`,
  title: relation.label,
  meta: rangeLabel(relation),
  text: relation.text,
  record: relation,
})))
const goalRows = computed(() => props.record.goal_records.map((goal) => ({
  key: goal.record_id || `${goal.job_id}-${goal.revision}`,
  title: rangeLabel(goal),
  meta: '',
  text: goal.text,
  record: goal,
})))
const threadRows = computed(() => props.record.open_threads.map((thread) => ({
  key: thread.thread_id,
  title: thread.thread_key || tr('characters.thread'),
  meta: rangeLabel(thread),
  text: thread.text,
  record: thread,
})))
</script>

<template>
  <div class="au-fold__body">
    <section class="au-group">
      <h4>{{ tr('characters.attitude') }} · {{ attitudeRows.length }}</h4>
      <AuditRecords :rows="attitudeRows" :sources="sources" />
    </section>
    <section class="au-group">
      <h4>{{ tr('characters.goals') }} · {{ goalRows.length }}</h4>
      <AuditRecords :rows="goalRows" :sources="sources" />
    </section>
    <section class="au-group" data-testid="observer-open-threads">
      <h4>{{ tr('characters.threads') }} · {{ threadRows.length }}</h4>
      <AuditRecords :rows="threadRows" :sources="sources" />
    </section>
  </div>
</template>
